module.exports = __webpack_public_path__ + "img/03Overseas_remittance.4b9cf818.png";